import { useState } from 'react';
import type { BenefitDesignInputs, CombinedFilterType } from '@/features/shop-insurance';

export const BENEFIT_DESIGN_DEFAULT_INPUTS: BenefitDesignInputs = {
  monthlyBenefit: null,
  benefitDuration: null,
  inflationProtection: null,
};

export function useBenefitDesignInputs() {
  const [monthlyBenefit, setMonthlyBenefit] = useState<number | null>(null);
  const [benefitDuration, setBenefitDuration] = useState<CombinedFilterType | null>(
    BENEFIT_DESIGN_DEFAULT_INPUTS.benefitDuration,
  );
  const [inflationProtection, setInflationProtection] = useState<CombinedFilterType | null>(
    BENEFIT_DESIGN_DEFAULT_INPUTS.inflationProtection,
  );

  const inputs: BenefitDesignInputs = {
    monthlyBenefit,
    benefitDuration,
    inflationProtection,
  };

  return {
    inputs,
    setMonthlyBenefit,
    setBenefitDuration,
    setInflationProtection,
  };
}
